<template>
  <div class="beefCont">
    <img src="../assets/imgs/95/bg.jpg" class="bg" alt="" />
    <Qrcode :pic="95" />
    <div class="phoneCommon">
        咨询电话：<a href="tel:028-87705725" style="color:#fff">028-87705725</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";
.beefCont {
  width: 100vw;
  position: relative;
  .bg {
    width: 100%;
    height: 70.74rem;
    display: block;
  }
}
</style>